<template>
    <div class="marquee"
         v-if="advertising.length>0">
        <div class="container-xl"
             v-for="(ad, index) in advertising" :key="index"
             @click="goActivity(ad.link)">
            <span class="d-inline-block">
                <img src="@/assets/images/home/gift.svg"
                     width="20px"
                     class="mr-1 mb-1 gift" /> {{ad.title}}
                <a v-if="ad.content === '預約保障諮詢'"
                   class="link text-nowrap"
                   href="javascript:void(0)">
                    手刀前往
                    <img src="@/assets/images/home/redArrow.svg"
                         class="arrow" />
                </a>
            </span>
        </div>
        <Notification />
    </div>
</template>
<script>
import { request } from '@/service';
import Notification from '@/components/Notification.vue';

export default {
    name: 'Advertising',
    components: {
        Notification
    },
    data() {
        return {
            advertising: []
        };
    },
    created() {
        this.getSaleActivity();
    },
    methods: {
        getSaleActivity() {
            request({
                method: 'POST',
                api: '/api/getSaleActivity',
                base: true,
                data: {
                    srcId: 'FBAG',
                }
            })
                .then(res => {
                    this.advertising = res.data.saleActivityList;
                }).catch((error) => {
                    this.$notify({
                        group: 'alert',
                        title: error.message || error.data[0].error,
                        type: 'error',
                    });
                });
        },
        goActivity(adLink) {
            if (adLink) {
                window.open(adLink);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.marquee {
    line-height: 1.2;
    background-color: #fff3cb;
    color: #ff5757;
    font-weight: bolder;
    font-size: 1rem;
    cursor: pointer;
    padding: 9px 0 8px 0;
    @include media-breakpoint-up(md) {
        font-size: 1.125rem;
        padding: 12px 0 8px 0;
    }
    .gift {
        animation: shake 0.5s ease-in-out infinite;
    }
    @keyframes shake {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(30deg);
        }
        100% {
            transform: rotate(0deg);
        }
    }
    .link {
        font-size: 0.875rem;
        color: #ff5757;
        position: relative;
        @include media-breakpoint-up(md) {
            font-size: 1rem;
        }
        &::after {
            content: '';
            width: 55px;
            height: 1px;
            background-color: #ff5757;
            position: absolute;
            right: 14px;
            bottom: 1px;
            @include media-breakpoint-up(md) {
                width: 62px;
            }
        }
    }
    .container-xl {
        max-width: 1136px;
    }
    .arrow {
        transform: rotate(270deg);
        width: 13px;
        margin-left: -3px;
        @include media-breakpoint-up(md) {
            width: 12px;
            margin-left: -2px;
        }
    }
}
</style>
